/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ trackNumber: NonNullable<unknown>, type: NonNullable<unknown> }} Track_Label_Type_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Track {trackNumber} type: {type}" |
*
* @param {Track_Label_Type_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const track_label_type_aria_label = /** @type {((inputs: Track_Label_Type_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Track_Label_Type_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Piste ${i?.trackNumber} type: ${i?.type}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Track ${i?.trackNumber} Typ: ${i?.type}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Tipo di traccia ${i?.trackNumber}: ${i?.type}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Тип трека ${i?.trackNumber}: ${i?.type}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Pista ${i?.trackNumber} tipo: ${i?.type}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`轨道 ${i?.trackNumber} 类型：${i?.type}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`トラック ${i?.trackNumber} タイプ: ${i?.type}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`ट्रैक ${i?.trackNumber} प्रकार: ${i?.type}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Faixa ${i?.trackNumber} tipo: ${i?.type}`)
	return /** @type {LocalizedString} */ (`Track ${i?.trackNumber} type: ${i?.type}`)
});